import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import LangContext, { i18n } from "modules/shared/context/langContext";
import { Button, Row, Spin, Table, Modal, Tooltip } from "antd";

class RescheduleLog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      visible,
      handleModalCancel,

      data,
    } = this.props;

    let columns = [
      {
        //วันที่ทำรายการ
        title: i18n[this.props.language].t.transaction_date,
        dataIndex: "created_at",
        align: "center",
        width: 130,
        fixed: "left",
        render: (text, record) => (
          <span>
            {record.created_at ? (
              <Tooltip
                placement="top"
                title={`${record.created_at}`}
                arrowPointAtCenter
              >
                <span>{`${record.created_at}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        //ผู้เลื่อนนัด/แจ้งปัญหา
        title: i18n[this.props.language].r.rescheduledBy,
        dataIndex: "reschedule_by",
        align: "center",
        width: 120,
        ellipsis: true,
        render: (text, record) => (
          <span>
            {record.reschedule_by ? (
              <Tooltip
                placement="top"
                title={`${record.reschedule_by}`}
                arrowPointAtCenter
              >
                <span>{`${record.reschedule_by}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        //สาเหตุ
        title: i18n[this.props.language].r.rescheduleReason,
        dataIndex: "reschedule_reason",
        align: "center",
        ellipsis: true,
        width: 150,
        render: (text, record) => (
          <span>
            {record.reschedule_reason ? (
              <Tooltip
                placement="top"
                title={`${record.reschedule_reason}`}
                arrowPointAtCenter
              >
                <span>{`${record.reschedule_reason}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        //รายละเอียด
        title: i18n[this.props.language].d.detail,
        dataIndex: "technician_rescheduled_note",
        align: "center",
        ellipsis: true,
        width: 180,
        render: (text, record) => (
          <span>
            {record.technician_rescheduled_note ? (
              <Tooltip
                placement="top"
                title={`${record.technician_rescheduled_note}`}
                arrowPointAtCenter
              >
                <span>{`${record.technician_rescheduled_note}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        //ชื่อผู้ติดต่อ
        title: i18n[this.props.language].c.contactName,
        dataIndex: "customer_contract_name",
        align: "center",
        width: 150,
        ellipsis: true,
        render: (text, record) => (
          <span>
            {record.customer_contract_name ? (
              <Tooltip
                placement="top"
                title={`${record.customer_contract_name}`}
                arrowPointAtCenter
              >
                <span>{`${record.customer_contract_name}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        //วันที่เลื่อนนัด
        title: i18n[this.props.language].r.rescheduledDate,
        dataIndex: "reschedule_date_new",
        align: "center",
        width: 120,
        render: (text, record) => (
          <span>
            {record.reschedule_date_new ? (
              <Tooltip
                placement="top"
                title={`${record.reschedule_date_new}`}
                arrowPointAtCenter
              >
                <span>{`${record.reschedule_date_new}`}</span>
              </Tooltip>
            ) : (
              "-"
            )}
          </span>
        ),
      },
    ];

    return (
      <Modal
        className="modal-reschedule-log"
        title={i18n[this.props.language].r.rescheduleLog}
        visible={visible}
        onCancel={() => {
          handleModalCancel();
        }}
        okText={null}
        width={900}
        closable={false}
        keyboard={false} // This prevents closing on escape
        maskClosable={false} // This prevents closing on blur
        footer={
          <Row type="flex" justify="end">
            <Button
              type="button"
              onClick={() => {
                handleModalCancel();
              }}
            >
              {i18n[this.props.language].c.cancel}
            </Button>
          </Row>
        }
        destroyOnClose={true}
      >
        {data.length > 0 && (
          <Table
            bordered
            dataSource={data ? data : []}
            pagination={data.length > 5 ? { pageSize: 5 } : false}
            rowKey={(record) => record.id}
            className="table-reschedule-log"
            columns={columns}
            size="small"
          />
        )}
      </Modal>
    );
  }
}

export default connect(
  ({ servicerepairdevice, auth, ui: { language } }) => ({
    servicerepairdevice,
    auth,
    language,
  }),
  {}
)(RescheduleLog);
